export default function Footer() {
  return (
    <footer className="bg-teal-600 py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white">
            © 2025 A A D LIMA VERDE LTDA. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white hover:text-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
